import {FilterList, FilterListItem} from 'react-admin'
import DoneAllIcon from '@material-ui/icons/DoneAll';

const EmployeeAssignedFilter = (props) => {

    let values = {'true': {}, 'false': {}}
    values['true'][props.source] = true
    values['false'][props.source] = false

    return (
        <FilterList
            label={`ra.field.${props.source}`}
            icon={<DoneAllIcon/>}
        >
            <FilterListItem
                label="ra.field.employeeAssigned.true"
                value={values['true']}
            />
            <FilterListItem
                label="ra.field.employeeAssigned.false"
                value={values['false']}
            />
        </FilterList>

    )
};

export default EmployeeAssignedFilter
